import React from 'react';
import { useTranslation } from '@hooks/useTranslation';
import './NotesField.scss';

const NotesField = ({
    value,
    onChange,
    disabled = false,
    name = 'notes',
    label = 'common.notes',
    placeholder = 'common.notes_placeholder',
    rows = 3,
    required = false
}) => {
    const { t } = useTranslation();

    return (
        <div className="form-group">
            <label htmlFor={name}>
                {t(label)}{required && ' *'}
            </label>
            <textarea
                id={name}
                name={name}
                value={value}
                onChange={onChange}
                disabled={disabled}
                rows={rows}
                className="form-control"
                placeholder={t(placeholder)}
            />
        </div>
    );
};

export default NotesField;
